export default __webpack_public_path__ + "static/media/newbg.96bd71ef.png";